import { useRef } from "react";
import { useEffect } from "react";


export default function SwitchSelectorButton({ children, active = false, onClick, className = '', disabled = false }) {

    var classes = className;
    if (active) {
        classes += ' active ';
    }
    if (disabled) {
        onClick = null;
    }


    return <button
        disabled={disabled}
        className={`SwitchSelectorButton ${classes}`}
        onClick={onClick}>
        {children}
    </button>
}